import React from "react";
import "./page2Styles.css";
import { motion } from "framer-motion";
import page2Img1 from "../../Assets/1x/Asset 9.png";
import page2Img2 from "../../Assets/1x/Asset 10.png";
import page2Img3 from "../../Assets/1x/Asset 11.png";
import page2Img4 from "../../Assets/1x/Asset 12.png";
import page2Img5 from "../../Assets/1x/Asset 14.png";
import page2Img6 from "../../Assets/1x/Asset 15.png";
import page2Img7 from "../../Assets/1x/Asset 16.png";
import page2Img8 from "../../Assets/1x/Asset 17.png";

function Page2() {
  // detect mobile breakpoint
  //const isMobile = window.innerWidth <= 768;
  const isMobile = true;

  // Define a creative text animation variant for the starter text.
  const textVariant = {
    initial: { opacity: 0, y: 20, letterSpacing: "5px" },
    animate: { opacity: 1, y: 0, letterSpacing: "normal" },
    transition: { duration: 1 }
  };

  // You can keep all other animations on images as before.
  const imageVariant = {
    initial: { opacity: 0, y: 20, scale: 0.95, rotate: 2 },
    animate: { opacity: 1, y: 0, scale: 1, rotate: 0 },
    transition: { duration: 1.5 }
  };

  return (
    <div className="page2">
      <div className="page2-block">
        <div className="page2-block-main-content-block">
          {/* Starter text with creative animation */}
          <motion.p 
            className="page2-block-main-content-block-starter-text"
            initial="initial"
            whileInView="animate"
            viewport={{ once: isMobile }}
            variants={textVariant}
          >
            2000 წელს ნებისმიერ მსურველს შეეძლო დაეწერა წერილი, 
            რომელსაც ადრესატი, გზავნილის ავტორის სურვილისამებრ,
            მიიღებდა და მიიღებს 5,10, 25, 50 ან 100 წლის შემდეგ.
            წერილები განთავსდა სპეციალურ სკივრებში და 
            ინახება ეროვნულ არქივში.
          </motion.p>
          
          {/* First Image Block */}
          <div className="page2-block-main-content-block-firstImg-block">
            <motion.img
              src={page2Img1}
              className="page2-block-main-content-block-firstImg-block-img1"
              alt="First image"
              initial={imageVariant.initial}
              whileInView={imageVariant.animate}
              transition={{ ...imageVariant.transition, delay: 0 }}
              viewport={{ once: isMobile }}
            />
            <motion.img
              src={page2Img2}
              className="page2-block-main-content-block-firstImg-block-img2"
              alt="Second image"
              initial={imageVariant.initial}
              whileInView={imageVariant.animate}
              transition={{ ...imageVariant.transition, delay: 0.1 }}
              viewport={{ once: isMobile }}
            />
            <motion.img
              src={page2Img3}
              className="page2-block-main-content-block-firstImg-block-img3"
              alt="Third image"
              initial={imageVariant.initial}
              whileInView={imageVariant.animate}
              transition={{ ...imageVariant.transition, delay: 0.2 }}
              viewport={{ once: isMobile }}
            />
          </div>

          {/* 1st-2nd images mobile */}
          <div className="page2-images-block" style={{display: 'none'}}>
            <div>
            <motion.img
                src={page2Img1}
                className="page2-block-img1"
                alt="First image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0 }}
                viewport={{ once: isMobile }}
            />
            </div>
            <div>
            <motion.img
                src={page2Img2}
                className="page2-block-img2"
                alt="Second image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.1 }}
                viewport={{ once: isMobile }}
            />
            </div>
            <div>
            <motion.img
                src={page2Img3}
                className="page2-block-img3"
                alt="Third image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.2 }}
                viewport={{ once: isMobile }}
            />
            </div>
            <div className="page2-block-text">
              <p>
              სკივრი გაიხსნა 2005, 2010 წლებში და
              ახლახან - 2025 წლის 10 მარტს.
              </p>
            </div>
            <div>
            <motion.img
                src={page2Img4}
                className="page2-block-img4"
                alt="Fourth image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.1 }}
                viewport={{ once: isMobile }}
            />
            </div>
            <div>
              <motion.img
                  src={page2Img5}
                  className="page2-block-img6"
                  alt="Fifth image"
                  initial={imageVariant.initial}
                  whileInView={imageVariant.animate}
                  transition={{ ...imageVariant.transition, delay: 0.2 }}
                  viewport={{ once: isMobile }}
              />
            </div>
            <div>
            <motion.img
                src={page2Img7}
                className="page2-block-img5"
                alt="Seventh image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.15 }}
                viewport={{ once: isMobile }}
            />
            </div>
            <div>
            <motion.img
                src={page2Img6}
                className="page2-block-img7"
                alt="Sixth image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.25 }}
                viewport={{ once: isMobile }}
            />
            </div>
            <div>
            <motion.img
                src={page2Img8}
                className="page2-block-img8"
                alt="Eighth image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.3 }}
                viewport={{ once: isMobile }}
            />
            </div>
          </div>
          
          {/* Second Image Block */}
          <div className="page2-block-main-content-block-secondImg-block">
            <div className="page2-block-main-content-block-secondImg-block-right-block">
              <motion.img
                src={page2Img4}
                className="page2-block-main-content-block-secondImg-block-right-block-img1"
                alt="Fourth image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.1 }}
                viewport={{ once: isMobile }}
              />
              <motion.img
                src={page2Img7}
                className="page2-block-main-content-block-secondImg-block-right-block-img2"
                alt="Seventh image"
                initial={imageVariant.initial}
                whileInView={imageVariant.animate}
                transition={{ ...imageVariant.transition, delay: 0.15 }}
                viewport={{ once: isMobile }}
              />
            </div>
            <div className="page2-block-main-content-block-secondImg-block-left-block">
              <p className="page2-block-main-content-block-secondImg-block-left-block-text">
                სკივრი გაიხსნა 2005, 2010 წლებში და 
                ახლახან - 2025 წლის 10 მარტს.
              </p>
              <div className="page2-block-main-content-block-secondImg-block-left-block-img-block">
                <motion.img
                  src={page2Img5}
                  className="page2-block-main-content-block-secondImg-block-left-block-img1"
                  alt="Fifth image"
                  initial={imageVariant.initial}
                  whileInView={imageVariant.animate}
                  transition={{ ...imageVariant.transition, delay: 0.2 }}
                  viewport={{ once: isMobile }}
                />
                <motion.img
                  src={page2Img6}
                  className="page2-block-main-content-block-secondImg-block-left-block-img2"
                  alt="Sixth image"
                  initial={imageVariant.initial}
                  whileInView={imageVariant.animate}
                  transition={{ ...imageVariant.transition, delay: 0.25 }}
                  viewport={{ once: isMobile }}
                />
                <motion.img
                  src={page2Img8}
                  className="page2-block-main-content-block-secondImg-block-left-block-img3"
                  alt="Eighth image"
                  initial={imageVariant.initial}
                  whileInView={imageVariant.animate}
                  transition={{ ...imageVariant.transition, delay: 0.3 }}
                  viewport={{ once: isMobile }}
                />
              </div>
            </div>
          </div>
          
          {/* Video remains unchanged */}
          <div className="page2-block-palitra-video-block">
            <video className="video2" preload="true" playsinline="" webkit-playsinline="" controls poster="https://kvirispalitra.ge/special/gzavnilebi/video2_prev.jpg">
              <source src="https://kvirispalitra.ge/special/gzavnilebi/video2.mp4" type="video/mp4" />
              <source src="https://kvirispalitra.ge/special/gzavnilebi/video2.mp4" type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page2;
